import '@/App.css';
import '@/index.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import DashboardPage from '@/pages/DashboardPage';
import AllocationPlannerPage from '@/pages/AllocationPlannerPage';
import ProjectionsPage from '@/pages/ProjectionsPage';
import MonthlyRollingProjectionsPage from '@/pages/MonthlyRollingProjectionsPage';
import SmartProjectionsPage from '@/pages/SmartProjectionsPage';
import InventoryReconPage from '@/pages/InventoryReconPage';
import HistoricalSnapshotsPage from '@/pages/HistoricalSnapshotsPage';
import AppShell from '@/components/AppShell';
import { Toaster } from '@/components/ui/sonner';

import { AuthProvider } from '@/auth/AuthContext';
import AuthCallback from '@/auth/AuthCallback';
import LoginModal from '@/auth/LoginModal';
import ProtectedRoute from '@/auth/ProtectedRoute';

// AppRouter detects the Emergent OAuth fragment `#session_id=...` SYNCHRONOUSLY
// during render and hands off to AuthCallback before any other route mounts.
// useEffect would run after first render — too late, and we'd race with the
// AuthProvider's /auth/me probe.
//
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      {/* Auth-only routes — no AppShell. */}
      <Route path="/" element={<LoginModal open />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      {/* Every business page is gated by ProtectedRoute. */}
      <Route path="/dashboard"            element={<ProtectedRoute><AppShell><DashboardPage /></AppShell></ProtectedRoute>} />
      <Route path="/allocation"           element={<ProtectedRoute><AppShell><AllocationPlannerPage /></AppShell></ProtectedRoute>} />
      <Route path="/projections"          element={<ProtectedRoute><AppShell><ProjectionsPage /></AppShell></ProtectedRoute>} />
      <Route path="/rolling-projections"  element={<ProtectedRoute><AppShell><MonthlyRollingProjectionsPage /></AppShell></ProtectedRoute>} />
      <Route path="/smart-projections"    element={<ProtectedRoute><AppShell><SmartProjectionsPage /></AppShell></ProtectedRoute>} />
      <Route path="/inventory-recon"      element={<ProtectedRoute><AppShell><InventoryReconPage /></AppShell></ProtectedRoute>} />
      <Route path="/historical-snapshots" element={<ProtectedRoute><AppShell><HistoricalSnapshotsPage /></AppShell></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
